import { Routes } from "@angular/router";
import { UssToolboxWrapperComponent } from "./features/uss-toolbox/components/uss-toolbox-wrapper/uss-toolbox-wrapper.component";
import { DashboardComponent } from "./features/dashboard/components/dashboard/dashboard.component";
import { MsalGuard } from "@azure/msal-angular";
import { RoleGuard } from "./guards/role-guard/role.guard";
import { Role } from "./models/role.enum";
import { AuthGuard } from "./guards/auth/auth.guard";
import { NonProductionGuard } from "./guards/non-production/non-production.guard";

export const routes: Routes = [
  {
    path: "",
    component: UssToolboxWrapperComponent,
    canActivate: [MsalGuard],
    children: [
      {
        path: "",
        pathMatch: "full",
        redirectTo: "dashboard",
      },
      {
        path: "dashboard",
        component: DashboardComponent,
        canActivate: [AuthGuard, RoleGuard],
        data: { roles: [] }, // Accessible to all roles
      },
      {
        path: "unauthorized",
        loadComponent: () =>
          import(
            "./shared/components/unauthorized/unauthorized.component"
          ).then((m) => m.UnauthorizedComponent),
        canActivate: [AuthGuard],
      },
      {
        path: "file-upload",
        loadComponent: () =>
          import(
            "./features/file-upload/components/file-upload/file-upload.component"
          ).then((m) => m.FileUploadComponent),
        canActivate: [AuthGuard, RoleGuard],
        data: {
          roles: [
            Role.PRICE_CARD_MAINTAINER,
            Role.ADMIN,
            Role.CONTRACT_PRICE_MAINTAINER,
            Role.RATE_CARD_MAINTAINER,
            Role.COMPETITOR_MAINTAINER,
          ],
        },
      },
      {
        path: "master",
        loadChildren: () =>
          import("./features/master/master.routes").then((m) => m.masterRoutes),
        canActivate: [AuthGuard, RoleGuard],
        data: { roles: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER] },
      },
      {
        path: "price",
        loadChildren: () =>
          import("./features/price/price.routes").then((m) => m.pricingRoutes),
        canActivate: [AuthGuard, RoleGuard],
        data: {
          roles: [
            Role.PRICE_CARD_MAINTAINER,
            Role.ADMIN,
            Role.CONTRACT_PRICE_MAINTAINER,
          ],
        },
      },
      {
        path: "price-v2",
        loadChildren: () =>
          import("./features/price-v2/price-v2.routes").then((m) => m.pricingV2Routes),
        canActivate: [AuthGuard, RoleGuard],
        data: {
          roles: [
            Role.PRICE_CARD_MAINTAINER,
            Role.ADMIN,
            Role.CONTRACT_PRICE_MAINTAINER,
          ],
        },
      },
      {
        path: "fence-pricing",
        loadChildren: () =>
          import("./features/fence-pricing/fence-pricing.routes").then(
            (module) => module.fencePricingRoutes
          ),
        canActivate: [AuthGuard, RoleGuard],
        data: {
          roles: [
            Role.PRICE_CARD_MAINTAINER,
            Role.ADMIN,
            Role.CONTRACT_PRICE_MAINTAINER,
          ],
        },
      },
      {
        path: "rate-card",
        loadChildren: () =>
          import("./features/rate-card/rate-card.routes").then(
            (m) => m.rateCardRoutes
          ),
        canActivate: [AuthGuard, RoleGuard],
        data: {
          roles: [
            Role.ADMIN,
            Role.COMPETITOR_MAINTAINER,
            Role.RATE_CARD_VIEWER,
            Role.RATE_CARD_MAINTAINER,
          ],
        },
      },
      {
        path: "role-permissions",
        loadChildren: () =>
          import("./features/role-permissions/role-permissions.routes").then(
            (m) => m.rolePermissionsRoutes
          ),
        canActivate: [RoleGuard],
        data: { roles: [Role.ADMIN] },
      },
      {
        path: "export-files",
        loadComponent: () =>
          import(
            "./shared/components/export-files/export-files.component"
          ).then((m) => m.ExportFilesComponent),
        canActivate: [AuthGuard, RoleGuard],
        data: { roles: [] }, // Accessible to all roles
      },
      {
        path: "audit-trail",
        loadComponent: () =>
          import(
            "./shared/components/audit-trail/audit-trail.component"
          ).then((m) => m.AuditTrailComponent),
        canActivate: [AuthGuard, RoleGuard],
        data: { roles: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER] },
      },
      {
        path: "db-sync",
        loadComponent: () =>
          import(
            "./features/db-sync/components/db-sync/db-sync.component"
          ).then((m) => m.DbSyncComponent),
        canActivate: [AuthGuard, RoleGuard, NonProductionGuard],
        data: { roles: [Role.ADMIN, Role.PRICE_CARD_MAINTAINER] },
      },
      {
        path: "analytics",
        loadComponent: () =>
          import(
            "./features/analytics/components/analytics/analytics.component"
          ).then((m) => m.AnalyticsComponent),
        canActivate: [AuthGuard, RoleGuard],
        data: { roles: [Role.ADMIN,Role.RATE_CARD_MAINTAINER] },
      },
      {
        path: "**",
        redirectTo: "dashboard",
      },
    ],
  },
];
